module.exports = __webpack_public_path__ + "static/media/Pitch.472e1e25.pdf";